import { defineMessages } from 'react-intl'

import { VEHICLE_COMPONENT } from './constants'

export const vehicleComponentMessages = defineMessages({
  [VEHICLE_COMPONENT.EMPTY]: {
    id: 'dictionary.empty',
    defaultMessage: 'Empty'
  },
  [VEHICLE_COMPONENT.SEAT]: {
    id: 'dictionary.seat',
    defaultMessage: 'Seat'
  },
  [VEHICLE_COMPONENT.DRIVER]: {
    id: 'dictionary.driver',
    defaultMessage: 'Driver'
  },
  [VEHICLE_COMPONENT.DOOR]: {
    id: 'dictionary.door',
    defaultMessage: 'Door'
  },
  [VEHICLE_COMPONENT.WC]: {
    id: 'dictionary.wc',
    defaultMessage: 'WC'
  },
  [VEHICLE_COMPONENT.STAIRCASE]: {
    id: 'dictionary.staircase',
    defaultMessage: 'Staircase'
  }
})
